import axios from "axios"
import { handleConfigError, setBearerToken } from "../utils/api"

export const axiosAssetDashApi = axios.create({
  baseURL: process.env.REACT_APP_ASSETDASH_API,
});

axiosAssetDashApi.interceptors.request.use(setBearerToken, handleConfigError);
